import HttpRequest from './HttpRequest'

class StatusProportionCarryComplaintsProvider extends HttpRequest {
  findAll (query) {
    return this.get('/status-proportion-carry-complaints/', query)
  }
}

export default StatusProportionCarryComplaintsProvider
